'use strict';
/**
 * @author Maxim Seredkin
 */
// angular
import angular from "angular";
import classifier from "./module/classifier";
import handbook from "./module/handbook";

export default angular.module('investmentProject.enchiridion',
    [classifier, handbook])
    .name;

